<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
   <div class="header-bottom">
      <a href="" class="profile-name">{{ $page.props.auth.user.name }}</a> 
      <br><br>
      <w-button class="profile_user" outline md>{{$page.props.auth.user.display_roles.toString()}}</w-button>
    </div>
      <w-card bg-color="" class="">
         <w-alert
           class="my0 mb2 text-light"
           v-if="$message"
           error
           transition="bounce"
           plain
           round
           no-border
           dismiss
         >
            {{ $message }}
         </w-alert>
         <w-form @validate="simpan">

            <center>
                <div class="xs2">
                    <w-image
                        class="maa sh1 bdrsr d-block"
                        :src="$page.props.auth.user.avatar"
                        width="100"
                        height="100">
                    </w-image> 
                  </div>

                <div class="xs4">
                    
                     <w-input type="file" :preview="false" accept=" image/*" @input="uploadImg('\\App\\Models\\User')" v-model="files">Muat Naik Gambar Profil</w-input>
                    <br>
                      <div class="fw-normal my1 fs-1">  
                        <!-- <a :href="attahecment.url">{{ attahecment.name }}</a> <w-button  bg-color="error-dark1"  @click="deletelAttahecment(attahecment.id)" ><w-icon xs >fal fa-trash</w-icon></w-button> -->
                      </div>
                    
                </div>
            </center>
            <div class="spacer">Jenis Pengguna * :</div>
            <br>
            <w-radios v-model="user.lkp_jenis_pengguna_id" disabled :items="jenis_pengguna" @input="getCapaian()" inline :validators="[validators.required]"/>
            <div class="spacer"></div>
            <br>
            <w-input
               outline
               label="Nama Penuh *"
               class="mt3"
               type="text"
               placeholder="Nama Penuh"
               name="name"
               v-model="user.name"
               :validators="[validators.required]"
            />
            <template v-if="user.lkp_jenis_pengguna_id!=1">
               <br>
               <z-select 
                  outline
                  label="Warganegara *"  
                  v-model="user.warga_negara"
                  disabled
                  :items="[
                    { value: 1, label: 'Warganegara' },
                    { value: 2, label: 'Bukan Warganegara' },
                  ]"
                  :validators="[validators.required]"
               />
            </template>
            <template v-if="user.warga_negara == 2">
               <br>
               <z-select 
                  outline
                  class="mt3"
                  label="Negara *"  
                  v-model="user.lkp_negara_id"
                  :items="negara"
                  :validators="[validators.required]"
               />
               <br>
               <w-input
                  outline
                  label="No.  Passport *"
                  class="mt3"
                  type="text"
                  placeholder="No.  Passport"
                  name="no_id"
                  :disabled="user.role_id==null || user.role_id ==''"
                  v-model="user.no_id"
                  disabled
                  :validators="[validators.required]"
                  v-if="user.warga_negara == 2"
               />
            </template>
            <template v-else>
               <br>
               <w-input
                  outline
                  label="No. Kad Pengenalan *"
                  class="mt3"
                  type="text"
                  placeholder="No. Kad Pengenalan"
                  name="no_id"
                  disabled
                  v-model="user.no_id"
                  :validators="[validators.required]"
                  v-if="user.warga_negara != 2"
               />
            </template>
            <br>
            <w-input
               outline
               label="E-mel *"
               class="mt3"
               type="email"
               placeholder="Sila Masukkan E-mel"
               name="email"
               v-model="user.email"
               :validators="[validators.required, validators.email]"
            />
            <br>
            <w-input
              outline
              label="Nombor Telefon *"
              class="mt3"
              type="tel"
              placeholder="Sila Masukkan Nombor Telepon"
              name="no_tel"
              v-model="user.no_tel"
              :validators="[validators.required, validators.numeric]"
            />
            <br>
            <w-input
              outline
              label="Nombor Telefon Pejabat (Jika Ada)"
              class="mt3"
              type="tel"
              placeholder="Sila Masukkan Nombor Telepon Pejabat"
              name="no_tel_pejabat"
              v-model="user.no_tel_pejabat"
            />
         <template v-if="user.lkp_jenis_pengguna_id==1">
            <br>
            <z-select 
               outline
               :items="d_negeri" 
               label="Negeri *"  
               v-model="user.lkp_negeri_id"
               @input="getCawangan(2)"
               :validators="[validators.required]"/>
            <div class="spacer"></div>
            <br>
            <z-select 
               outline
               :items="cawangan" 
               label="Tempat Bertugas"
               @input="getAlamat()"
               v-model="user.lkp_cawangan_id"
               />
         </template>
            <w-textarea 
               outline 
               label="Alamat Surat Menyurat*"
               placeholder="Sila Masukkan Alamat"
               class="mt3"
               name="alamat"
               v-model="user.alamat"
               type="text-area"
               :validators="[validators.required]"/>
            <div class="spacer"></div>
            <br>
            <w-input outline label="Poskod *" class="mt3" name="poskod" v-model="user.kode" @input="getPoskodUtama()"/>
            <z-select outline class="mt4"  :items="bandar" label="Mukim/Bandar/Pekan *"  v-model="user.lkp_bandar_id" @input="getPoskod(user.lkp_bandar_id, 1)" :validators="[validators.required]"/>
            <z-select outline class="mt4"  :items="daerah" label="Daerah *"  v-model="user.lkp_daerah_id" @input="getBandar(user.lkp_daerah_id, 1)" :validators="[validators.required]"/>
            <z-select outline class="mt4"  :items="d_negeri" label="Negeri *"  v-model="user.lkp_negeri_id" @input="getDaerah(user.lkp_negeri_id, 1)" :validators="[validators.required]"/>
            <template v-if="$zutil.role('7') || $zutil.role('8')">
               <z-select outline class="mt4"  :items="d_negeri" label="Diselia oleh Negeri *"  v-model="user.lkp_diselia_negeri_id" :validators="[validators.required]"/>
               <w-input outline class="mt4" type="text" label="No. Siri Kad" placeholder="Sila Masukkan No. Siri Kad" v-model="user.no_siri" />
               <w-input
                     class="mt4"
                     label="Tempoh Sah Laku Sehingga *"
                     outline
                     type="date"
                     v-model="user.tarikh_lantikan"
                     :validators="[validators.required]"
                  />
               <br>
               <div class="spacer mt4">Kategori Kelulusan * :</div>
               <w-checkboxes
                           class="mt4"
                           outline
                           v-model="user.kategoriuser"
                           placeholder="Sila Pilih Kategori Kelulusan"
                           :items="[  
                              { value: 1, label: 'MVC' },
                              { value: 2, label: 'Surat Lantikan' },
                           ]"
                           inline
                           :validators="[validators.required]"
                     />
               <div class="form-row" v-if="user.kategoriuser.includes(1)">
                  <div class="mt3" v-if="user.id != 0 && user.kategoriuser.includes(1)">Muat Naik Sijil MVC * : <a v-if="attahecment_mvc.length > 0" :href="attahecment_mvc[0].url" target="_blank">{{attahecment_mvc[0].name}}</a></div>
                  <w-input
                     class="mt4"
                     type="file"
                     :preview="false"
                     accept="application/pdf"
                     v-model="files_mvc"
                     outline
                     label="Sijil MVC"
                     placeholder="Sila Muat Naik Sijil MVC"
                  >
                  </w-input>
                  <span style="color: black;font-size: 13px;"> **Sila Muat Naik Sijil MVC</span>
               </div>
               <div class="form-row" v-if="user.kategoriuser.includes(2)">
                  <div class="mt3" v-if="user.id != 0 && user.kategoriuser.includes(2)">Muat Naik Sijil Lantikan * : <a v-if="attahecment.length > 0" :href="attahecment[0].url" target="_blank">{{attahecment[0].name}}</a></div>
                  <w-input
                     type="file"
                     class="mt4"
                     :preview="false"
                     accept="application/pdf"
                     v-model="files"
                     outline
                     label="Sijil Lantikan"
                     placeholder="Sila Muat Naik Sijil Lantikan"
                  >
                  </w-input>
                  <span style="color: black;font-size: 13px;"> **Sila Muat Naik Sijil Lantikan</span>
               </div>
            </template>
            <!-- <w-select 
               outline
               :items="bandar" 
               label="Daerah *"  
               v-model="user.lkp_bandar_id"
               :validators="[validators.required]"/>
            <div class="spacer"></div>
            <br>
            <template v-if="user.lkp_jenis_pengguna_id == 2">
               <w-input
                     outline
                     label="Poskod"
                     class="mt3"
                     type="tel"
                     placeholder="Sila Masukkan Poskod"
                     name="poskod"
                     v-model="user.kode"
                     @change="getPoskodUtama()"
                     :validators="[validators.required, validators.numeric]"
                 />
            </template>
            <template v-else>
               <w-select 
                  outline
                  :items="poskod" 
                  label="Poskod"  
                  :validators="[validators.required]"
                  v-model="user.lkp_poskod_id"
                  @input="getBandarPoskod()"
               />
            </template>
            <br>
            <template v-if="user.lkp_jenis_pengguna_id==2">
            <w-select 
               outline
               :items="d_negeri" 
               label="Negeri *"  
               v-model="user.lkp_negeri_id"
               :validators="[validators.required]"/>
               <br>
            </template> -->



            
            <w-flex class="mt3" wrap align-center justify-end>
               <div class="spacer" />
                  <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
                     <w-button
                           class="my3"
                           type="submit"
                         >
                   <w-icon class="mr2" xs>fal fa-sign-in-alt</w-icon> SIMPAN
               </w-button>
            </w-flex>
         </w-form>
      </w-card>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'



export default {
  props: {
    d_user: [Array, Object],
    d_negeri: [Array, Object]
  },
  data() {
    return {
      resourceurl: 'se.pemungutan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Profil', route: '' },
      ],
      user: this.d_user,
      negeri : this.d_negeri,
      validators:[],
      form:[],
      files: [],
        attahecment : [], 
        country : [],
      bandar : [],
        poskod : [],
        negara : [],
        peran : [],
        jenis_pengguna : [],
        cawangan: [],
        daerah:[],
      files_mvc: [],
      files: [],
      attahecment_mvc: [],
      attahecment: [],
       
      
    }
  },
  methods: {
         tutup(){
            this.$inertia.visit(window.route('home'));
          },
         getCapaian(id){
            if(this.user.lkp_jenis_pengguna_id != null || this.user.lkp_jenis_pengguna_id != ''){
            this.user.peranan = '';
            this.user.lkp_bandar_id = '';
            this.user.lkp_poskod_id = '';
            this.user.lkp_cawangan_id = '';
            this.user.lkp_negeri_id = '';
            this.user.alamat = '';
            }
         },
         getPeranan(id){
            this.$zcomm.get(this.api_service + 'lookup/peranan/'+this.form.lkp_jenis_pengguna_id, {}).then(res => {
              this.peran = res
            })
         },

        getlkpJenisPengguna(){
            this.$zcomm.get(this.api_service + 'lookup/jenis_pengguna', {}).then(res => {
              this.jenis_pengguna = res
            })
        },

         getCawangan(id){
            if(id==2||this.user.lkp_negeri_id==null||this.user.lkp_negeri_id==''){
               this.user.lkp_bandar_id = '';
               this.user.lkp_poskod_id = '';
               this.user.lkp_cawangan_id = '';
               this.form.alamat = '';
            }
            if (this.user.lkp_negeri_id) {
               this.$zcomm.get(this.api_service + 'lookup/cawangan/'+this.user.lkp_negeri_id, {}).then(res => {
                 this.cawangan = res
               })
               this.getPoskodNegri(1);
            }
         },
         getPoskodNegri(id){
           this.$zcomm.get(this.api_service + 'lookup/poskod_negeri/'+this.user.lkp_negeri_id, {}).then(res => {
             this.poskod = res
           })
         },
         getAlamat(){
            this.$zcomm.get(this.api_service + 'lookup/alamat/'+this.user.lkp_cawangan_id, {}).then(res => {
            this.form.alamat = res.alamat
            this.user.lkp_bandar_id = res.lkp_bandar_id
            this.user.lkp_poskod_id = res.lkp_poskod_id
            this.user.lkp_daerah_id = res.lkp_daerah_id
               this.getBandar(1);
               this.getPoskod()
               this.getDaerah()
            })
         },
         getNegara(){
            this.$zcomm.get(this.api_service + 'lookup/negara', {}).then(res => {
              this.negara = res
            })
         },

        getBandar(id){
            this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.user.lkp_daerah_id, {}).then(res => {
               this.bandar = res
            })
         },

         getPoskod(id){
            this.$zcomm.get(this.api_service + 'lookup/poskod/'+this.user.lkp_bandar_id, {}).then(res => {
              this.poskod = res
            })
         },
         getBandarPoskod(id){
            this.user.lkp_bandar_id = '';
            this.$zcomm.get(this.api_service + 'lookup/bandar_poskod/'+this.user.lkp_poskod_id, {}).then(res => {
               this.bandar = res
            })
         },
         getDaerah(i, p){
            if (p ==1) {
               this.user.lkp_daerah_id = '';
            }
            this.form.p = parseInt(p)
            this.$zcomm.get(this.api_service + 'lookup/daerah/'+this.user.lkp_negeri_id, {}).then(res => {
              this.daerah = res
              
            })
         },

        getPoskodUtama(){
            if(this.user.kode.length == 5){
              this.$zcomm.get(this.api_service + 'lookup/poskod_utama/'+this.user.kode, {}).then(res => {
                  if(res.lkp_bandar_id){
                    this.$zcomm.get(this.api_service + 'lookup/poskod/'+res.lkp_bandar_id, {}).then(r => {
                      this.poskod = r
                      this.user.lkp_poskod_id = res.lkp_poskod_id
                    })
                    this.$zcomm.get(this.api_service + 'lookup/bandar/'+res.lkp_daerah_id, {}).then(r => {
                      this.bandar = r
                      this.user.lkp_bandar_id = res.lkp_bandar_id
                    })
                    this.$zcomm.get(this.api_service + 'lookup/daerah/'+res.lkp_negeri_id, {}).then(r => {
                      this.daerah = r
                      this.user.lkp_daerah_id = res.lkp_daerah_id
                    })
                    this.user.lkp_negeri_id = res.lkp_negeri_id
                  }
              })
            }
            // this.$zcomm.get(this.api_service + 'lookup/poskod_utama/'+this.user.kode, {}).then(res => {
            //   // this.form.p = res.p
            //   this.user.lkp_negeri_id = res.lkp_negeri_id
            //   this.user.lkp_bandar_id = res.lkp_bandar_id
            //   this.user.lkp_poskod_id = res.lkp_poskod_id
            //   this.getPoskod(0)
            //   this.getBandar(0)
            // })
        },

        checkPoskod(){
          // alert(this.form.lkp_poskod_id);
          if(this.form.lkp_poskod_id == null){
            this.form.p = 0
          }
        },
        simpan() {
            this.$zcomm.post('profile-update',this.user).then(res => {
                console.log(res);
                  if (this.files !=[]) {
                     this.uploadLantikan(res);

                  }
                  if(this.files_mvc != []){
                     this.uploadMvc(res);
                  }
                this.$zutil.notify("Berjaya disimpan");
               //  this.$inertia.visit(this.$route('home'));
                  
                })
                 .catch(err => {
                })
        },
        uploadImg(item) 
        {  
           let formData = new FormData();
           for (var b in this.files) 
           {
               formData.append("files["+b+"]", this.files[b].file);
           }
           formData.append("model",item);
           formData.append("model_id", this.user.id);
           this.$zcomm.post('attahecment.upload_replace', formData)
               .then((res) => {
                    this.$inertia.visit(
                        window.route("profile", this.user.id),
                    );
                   
                    // this.$inertia.reload();
               })
               .catch((err) => {})
               .finally(() => {});
        },
      uploadMvc(item) 
         {  
         let formData = new FormData();
         for (var b in this.files_mvc) 
         {
              formData.append("files["+b+"]", this.files_mvc[b].file);
         }
         formData.append("model",'\\App\\Model\\SijilMvc');
         formData.append("model_id", item.id);
         this.$zcomm.post('attahecment.upload', formData)
            .then((res) => {
               // this.getAttahecment();
            })
            .catch((err) => {})
            .finally(() => {});
      },

      uploadLantikan(item) 
      {  
         let formData = new FormData();
         for (var b in this.files) 
         {
              formData.append("files["+b+"]", this.files[b].file);
         }
         formData.append("model",'\\App\\Model\\SijilLantikan');
         formData.append("model_id", item.id);
         this.$zcomm.post('attahecment.upload', formData)
            .then((res) => {
               // this.getAttahecment();
            })
            .catch((err) => {})
            .finally(() => {});
      },
      getAttahecment(item)
      {
         if(this.user.id){
         this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : this.user.id, model : '\\App\\Model\\SijilMvc'}).then(res => {
            this.attahecment_mvc = res
         })
            this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : this.user.id, model : '\\App\\Model\\SijilLantikan'}).then(res => {
            this.attahecment = res
         })
         }
      },
  
  },

  watch: {

  },
  mounted() {
   this.getPoskodUtama();
    this.getBandar(1);
    this.getAttahecment(1);
    this.getNegara();
    this.getlkpJenisPengguna();
    this.getCawangan(1)
  }
    
}
</script>
